import { render, staticRenderFns } from "./AccountantDashboard.vue?vue&type=template&id=59370983&scoped=true&"
import script from "./AccountantDashboard.vue?vue&type=script&lang=js&"
export * from "./AccountantDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59370983",
  null
  
)

export default component.exports